import { BorrowerDrillDownQuery } from 'ng2-app/models/sales-inventory/sales-inventory.model';

/** Load the first keyset page of one team's combined borrower drill-down (By-Team mode). */
export class LoadTeamBorrowerDrillDown {
  static readonly type = '[TeamBorrowers] Load Team Borrower Drill-Down';
  constructor(
    public teamId: number,
    public query: BorrowerDrillDownQuery,
    public overrideCache = false
  ) {}
}

/** Fetch and append the next keyset page of a team's borrower drill-down. */
export class LoadMoreTeamBorrowerDrillDown {
  static readonly type = '[TeamBorrowers] Load More Team Borrower Drill-Down';
  constructor(
    public teamId: number,
    public query: BorrowerDrillDownQuery
  ) {}
}
